// extracted by mini-css-extract-plugin
module.exports = {"container":"ShippingCostsTooltip_container__8OQt2","markdown":"ShippingCostsTooltip_markdown__leWpE","tooltip":"ShippingCostsTooltip_tooltip__cVnRw"};